import React from 'react';

import { cn } from '../../base/utils';

import type { SkeletonAnimation } from '../../skeleton/motion';

import { Skeleton } from '../Skeleton';

export interface SkeletonButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  animation?: SkeletonAnimation;
  /**
   * 按钮大小
   * @default 'md'
   */
  size?: 'sm' | 'md' | 'lg' | 'icon';
  /**
   * 是否圆角
   * @default false
   */
  rounded?: boolean;
}

const sizeMap = {
  sm: 'h-8 w-20',
  md: 'h-9 w-24',
  lg: 'h-10 w-28',
  icon: 'size-9',
};

/**
 * 按钮骨架屏组件
 */
export function SkeletonButton({
  className,
  size = 'md',
  rounded = false,
  ...props
}: SkeletonButtonProps) {
  return (
    <Skeleton
      className={cn(sizeMap[size], rounded ? 'rounded-full' : 'rounded-md', className)}
      {...props}
    />
  );
}
